import { z } from '@harvestiq/zod';
import { dbApiKeySchema } from './db-api-key';

export const createApiKeyRequestSchema = z.object({
  userId: z.string().uuid(),
  enabled: z.boolean(),
  label: z.string().optional(),
});
export type CreateApiKeyRequest = z.infer<typeof createApiKeyRequestSchema>;

export const createApiKeyResponseSchema = z.object({
  data: z.array(dbApiKeySchema),
});
export type CreateApiKeyResponse = z.infer<typeof createApiKeyResponseSchema>;

export const createApiKeyErrorResponseSchema = z.object({
  data: z.tuple([]),
  errors: z.array(z.object({ message: z.string() })),
});
